(() => {
  const section = document.getElementById('abb');
  if (!section) return;
  const query = window.location.search;
  const previewParameters = new Set(['view', 'preview_theme_id', 'pb', 'section_id', 'sections']);
  section.querySelectorAll('a.abb-offer-link').forEach((anchor) => {
    try {
      const destination = new URL(anchor.href, window.location.origin);
    const incoming = new URLSearchParams(query);
    incoming.forEach((value, key) => {
      if (previewParameters.has(key.toLowerCase())) return;
      if (!destination.searchParams.has(key)) destination.searchParams.append(key, value);
      });
      anchor.href = destination.toString();
    } catch (_) { /* Keep the Shopify-configured link if URL parsing fails. */ }
  });

  const counters = [...section.querySelectorAll('[data-countdown]')];
  if (counters.length) {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: section.dataset.countdownTimezone || 'America/New_York',
      year: 'numeric', month: '2-digit', day: '2-digit',
    });
    const dateKey = (timestamp) => {
      const parts = Object.fromEntries(formatter.formatToParts(new Date(timestamp)).map((part) => [part.type, part.value]));
      return Number(parts.year) * 10000 + Number(parts.month) * 100 + Number(parts.day);
    };
    const nextMidnight = (now) => {
      const today = dateKey(now);
      let low = now;
      let high = now + 27 * 60 * 60 * 1000;
      while (low < high) {
        const middle = Math.floor((low + high) / 2);
        if (dateKey(middle) > today) high = middle;
        else low = middle + 1;
      }
      return low;
    };
    let resetAt = nextMidnight(Date.now());
    const renderCountdown = () => {
      const now = Date.now();
      if (now >= resetAt) resetAt = nextMidnight(now);
      const remaining = Math.max(0, Math.ceil((resetAt - now) / 1000));
      const values = {
        hours: Math.floor(remaining / 3600),
        minutes: Math.floor((remaining % 3600) / 60),
        seconds: remaining % 60,
      };
      counters.forEach((counter) => {
        counter.querySelectorAll('[data-countdown-unit]').forEach((number) => {
          number.textContent = String(values[number.dataset.countdownUnit]).padStart(2, '0');
        });
      });
    };
    renderCountdown();
    window.setInterval(renderCountdown, 1000);
  }

  const track = section.querySelector('.abb-results-track');
  const previous = section.querySelector('.abb-results-prev');
  const next = section.querySelector('.abb-results-next');
  if (track && previous && next) {
    const updateControls = () => {
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    const scrollCard = (direction) => {
      const card = track.querySelector('.abb-result');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };
    previous.addEventListener('click', () => scrollCard(-1));
    next.addEventListener('click', () => scrollCard(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  }
})();
